import MDBox from 'components/MDBox';
import MDButton from 'components/MDButton';
import MDTypography from 'components/MDTypography';
import { NavLink } from 'react-router-dom';

const leaderboardColumnData = [
  {
    Header: 'Start date',
    accessor: 'createdAt',
    Cell: ({ row }) => {
      const date = new Date(row.original.createdAt);

      const day = String(date.getUTCDate()).padStart(2, '0');
      const month = String(date.getUTCMonth() + 1).padStart(2, '0'); // Months are 0-based
      const year = date.getUTCFullYear();
      const hours = String(date.getUTCHours()).padStart(2, '0');
      const minutes = String(date.getUTCMinutes()).padStart(2, '0');

      const formatted = `${day}.${month}.${year} at ${hours}:${minutes}`;
      return <>{formatted}</>;
    }
  },
  {
    Header: 'Entry ID',
    accessor: 'id'
  },

  {
    Header: '',
    accessor: 'player-details',
    Cell: ({ row }) => {
      return (
        <>
          <MDBox sx={{ display: 'flex', justifyContent: 'center' }}>
            <NavLink to={`/tournament/leaderboard/${row.original.id}`}>
              <MDButton fontSize='0.875rem' color='info'>
                View
              </MDButton>
            </NavLink>
          </MDBox>
        </>
      );
    }
  }
];
export default leaderboardColumnData;
